/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * "
 * State of the validation requirement
 */
export var ExternalValidationRequirementState;

(function (ExternalValidationRequirementState) {
  ExternalValidationRequirementState["VERIFIED"] = "verified";
  ExternalValidationRequirementState["MATCHED"] = "matched";
  ExternalValidationRequirementState["PENDING"] = "pending";
})(ExternalValidationRequirementState || (ExternalValidationRequirementState = {}));